import { create } from 'zustand';

const SELECTED_FLEET_STORAGE_KEY = 'selectedFleet';

const getStoredFleet = () => {
  try {
    const stored = localStorage.getItem(SELECTED_FLEET_STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    return null;
  }
};

const storeFleet = (fleet) => {
  try {
    if (fleet) {
      localStorage.setItem(SELECTED_FLEET_STORAGE_KEY, JSON.stringify(fleet));
    } else {
      localStorage.removeItem(SELECTED_FLEET_STORAGE_KEY);
    }
  } catch (error) {
    console.error('Failed to persist the selected fleet:', error);
  }
};

const useFleetStore = create((set) => ({
  allPodData: [],
  selectedFleet: getStoredFleet(),

  setAllPodData: (data) => set({ allPodData: data }),
  setSelectedFleet: (fleet) => {
    storeFleet(fleet);
    set({ selectedFleet: fleet });
  },
  setSelectedUnit: (unit) => set({ selectedUnit: unit }),
}));

export default useFleetStore;
